import React, { useState } from 'react';
import { toast } from 'sonner';
import { Panel, Empty } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { api, errMsg, fmtUsd, fmtDate } from '../../lib/api';

export default function AdminAllocations() {
  const { data: rows, reload } = useFetch('/admin/allocations');
  const { data: users } = useFetch('/admin/users');
  const [f, setF] = useState({ user_id: '', amount: '', reason: '' });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.user_id || !(Number(f.amount) > 0)) return toast.error('Select user and amount');
    try { await api.post('/admin/allocations', f); toast.success('Allocation created'); setF({ user_id: '', amount: '', reason: '' }); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-6" data-testid="admin-allocations">
      <Panel title="Manual Trading Allocation">
        <form onSubmit={submit} className="grid sm:grid-cols-4 gap-3">
          <select value={f.user_id} onChange={(e) => setF({ ...f, user_id: e.target.value })} className="h-11 px-3 rounded-lg bg-vj-charcoal border border-border text-sm text-foreground" data-testid="alloc-user">
            <option value="">Select user…</option>
            {(users || []).filter((u) => u.role === 'user').map((u) => <option key={u.id} value={u.id}>{u.email}</option>)}
          </select>
          <input type="number" step="0.01" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} placeholder="Amount" className="h-11 px-3 rounded-lg bg-vj-charcoal border border-border font-mono text-sm text-foreground" data-testid="alloc-amount" />
          <input value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} placeholder="Reason" className="h-11 px-3 rounded-lg bg-vj-charcoal border border-border text-sm text-foreground" data-testid="alloc-reason" />
          <button className="h-11 rounded-lg bg-vj-neon text-vj-obsidian font-semibold text-sm vj-glow-green" data-testid="alloc-submit">Allocate</button>
        </form>
        <p className="text-[11px] text-vj-grey mt-3">Allocations draw from a user's available balance and never exceed it. Each allocation is recorded in the ledger.</p>
      </Panel>
      <Panel title="Allocation History">
        {rows && rows.length ? (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-vj-grey border-b border-border"><th className="py-2 font-medium">User</th><th className="font-medium">Amount</th><th className="font-medium">Reason</th><th className="font-medium">By</th><th className="font-medium">Date</th></tr></thead>
            <tbody>{rows.map((r) => (
              <tr key={r.id} className="border-b border-border last:border-0">
                <td className="py-2.5 text-xs">{r.user_email}</td><td className="font-mono text-vj-gold">{fmtUsd(r.amount)}</td>
                <td className="text-xs">{r.reason}</td><td className="text-xs text-vj-grey">{r.by}</td><td className="text-xs text-vj-grey">{fmtDate(r.created_at)}</td>
              </tr>
            ))}</tbody>
          </table></div>
        ) : <Empty>No allocations yet.</Empty>}
      </Panel>
    </div>
  );
}
